// 接待结果取值。success_ 前缀是约定：统计按前缀汇总成功数，
// 以后加新方案只要沿用这个前缀，就自动计进成功率，不用再改统计 SQL。
export const SUCCESS_OUTCOMES = [
  { key: 'success_360', label: '办理360' },
  { key: 'success_180', label: '办理180' },
  { key: 'success_158', label: '办理158' },
  { key: 'success_credit', label: '办信用卡' },
]

// 跟进中不是结束状态：后端凡是「还没结果」的判断都把它算进去（交接、置顶、付款提醒）
export const SELECTABLE_OUTCOMES = [
  ...SUCCESS_OUTCOMES,
  { key: 'following', label: '跟进中' },
  { key: 'failed', label: '失败' },
]

// 已下架的老选项，只用于显示旧记录，不出现在下拉里。67不退 2026-09-30 Gavin 要求去掉
const LEGACY_LABELS = { success: '成功（未细分）', success_67: '67不退' }

export const outcomeLabel = (k) =>
  SELECTABLE_OUTCOMES.find(o => o.key === k)?.label || LEGACY_LABELS[k] || k

export const isSuccess = (k) => typeof k === 'string' && k.startsWith('success')
export const requiresPaymentVerification = (k) => isSuccess(k) && k !== 'success_credit'
